/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface TermoAceiteAtivo {
  id: string;
  conteudo: string;
}

interface State {
  isRequesting: boolean;
  successPayload: TermoAceiteAtivo | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: null,
  errors: []
};

const obterTermoAceiteAtivoSlice = createSlice({
  name: "identidade.termoAceite@obterTermoAceiteAtivo",
  initialState,
  reducers: {
    obterTermoAceiteAtivo: (state): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    obterTermoAceiteAtivoSuccess: (
      state,
      action: PayloadAction<TermoAceiteAtivo>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterTermoAceiteAtivoFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* obterDetalhe(params: { type: string }) {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/identidade/termo-aceite`
    );

    const { data }: { data: TermoAceiteAtivo } = response;
    yield put(obterTermoAceiteAtivoSuccess(data));
  } catch (error) {
    yield put(obterTermoAceiteAtivoFailed(formatError(error)));
  }
}

export const {
  obterTermoAceiteAtivo,
  obterTermoAceiteAtivoSuccess,
  obterTermoAceiteAtivoFailed
} = obterTermoAceiteAtivoSlice.actions;

export const { reducer } = obterTermoAceiteAtivoSlice;
export const saga = takeLatest(obterTermoAceiteAtivo.type, obterDetalhe);
